/* unplugin-vue-components disabled */import { render } from "./manageBonus.vue?vue&type=template&id=243aa6b5&scoped=true"
import script from "./manageBonus.vue?vue&type=script&lang=js"
export * from "./manageBonus.vue?vue&type=script&lang=js"

import "./manageBonus.vue?vue&type=style&index=0&id=243aa6b5&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243aa6b5"]])

export default __exports__